<template>
  <div class="video">
    <video autoplay loop muted>
    <source src="../assets/Danfoss DDP v8.mp4" type="video/mp4">
    </video>
<!--     <div class="controls">
      <button>PLAY</button>
      </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "home"
};
</script>
<style lang="scss" scoped>
.video{
  position: relative;
  width: 100vw;
  height: 100vw;
  z-index: 1;
  margin-top: 0 !important;
}
.video video{
  max-width: 100vw;
  height: auto;
  width: auto;
  position:absolute;
  z-index: 0;
  top: -40px;
}
.controls{
  position: absolute;
  z-index: 3;
  top: 10%;
  left: 10%;
}

</style>


